/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 新增修改客戶畫面
 * @module web/modules/department/components/MachineModal
 */

// ----- import from npm modules ----
import $ from 'jquery';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
import {BaseComponent} from 'web/components/BaseComponent';

// ----- constants -----
import {TITLE_MACHINE_NEW, TITLE_MACHINE_EDIT} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {addMachine, editMachine} from 'web/redux/actions/MachineActions';
import {Typeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const {flgStatus: flgStatusEnum} = enumList;

const MACHINE_TYPE_LIST = Object.keys(enumList.machineTypes).map((id) => ({
  id: Number(id),
  idString: id,
  label: enumList.machineTypes[id],
}));

export const DEFAULT_MACHINE_TYPE = MACHINE_TYPE_LIST[0];

const MachineModal = React.forwardRef((props, ref) => {
  const {
    toggleMachineAddModal,
    toggleMachineEditModal,
    reloadDepartmentList,
    mode,
    machineItem,
    onErrorHandle,
  } = props;
  const dispatch = useDispatch();
  const FLG_STATUS_SWITCH = [flgStatusEnum.inactive, flgStatusEnum.active];

  // const baseComponent = new BaseComponent(props);
  const [modalRecordYear, setModalRecordYear] = useState('');
  const [modalDeliveryCode, setModalDeliveryCode] = useState('');
  const [modalMachineModel, setModalMachineModel] = useState('');
  const [modalMachineSerialNumber, setModalMachineSerialNumber] = useState([]);
  const [modalMachineType, setModalMachineType] = useState([
    DEFAULT_MACHINE_TYPE,
  ]);
  const [modalMfgNo, setModalMfgNo] = useState('');
  const [modalECabinetNo, setModalECabinetNo] = useState('');
  const [modalMemo, setModalMemo] = useState('');
  const [imCode, setImCode] = useState('');
  const [flgStatus, toggleFlgStatus] = useState(flgStatusEnum.active);

  const [invalidShow, setInvalidShow] = useState('none');

  const typeInputReference = useRef(null);

  const isCreateMode = mode === enumList.modalMode.new;
  const modalIcon = isCreateMode ? '#ico-plus' : '#ico-edit';
  const modalTitleText = isCreateMode ? TITLE_MACHINE_NEW : TITLE_MACHINE_EDIT;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // 檢查表單是否驗證通過
    if (!checkValid(form)) return setInvalidShow('block');

    form.classList.add('was-validated');

    const req = {
      id: machineItem.machineId,
      recordYear: modalRecordYear,
      deliveryCode: modalDeliveryCode,
      model: modalMachineModel,
      serialNumber: modalMachineSerialNumber,
      imCode,
      type: modalMachineType[0].id,
      flgStatus,
      memo: modalMemo,
      mfgNo: modalMfgNo,
      eCabinetNo: modalECabinetNo,
    };
    if (mode === enumList.modalMode.edit) {
      submitEditMachine(req);
      toggleMachineEditModal(false);
    }
    if (mode === enumList.modalMode.new) {
      submitAddMachine(req);
      toggleMachineAddModal(false);
    }
    resetForm(form);
  };

  const checkValid = (form) => {
    if (form.checkValidity() === false) {
      showMessage(enumList.messageModalMode.error, '請填寫必填欄位');
      return false;
    }
    if (isNaN(Number(modalRecordYear))) {
      showMessage(enumList.messageModalMode.error, '請輸入正確的年份');
      return false;
    }
    return true;
  };

  const submitAddMachine = (req) => {
    dispatch(addMachine(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        showMessage(enumList.messageModalMode.info, '新增成功');
        toggleMachineAddModal(false);
        reloadDepartmentList();
      } else {
        toggleMachineAddModal(false);
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );

        console.error('fetchDepartmentList error', res);
      }
    });
  };

  const submitEditMachine = (req) => {
    dispatch(editMachine(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        const customerList = res.payload.result;
        showMessage(enumList.messageModalMode.info, '更新成功');
        toggleMachineEditModal(false);
        reloadDepartmentList();
      } else {
        toggleMachineEditModal(false);
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );
      }
    });
  };

  const resetForm = (form) => {
    form.classList.remove('was-validated');
    setModalRecordYear('');
    setModalDeliveryCode('');
    setModalMachineModel('');
    setModalMachineSerialNumber('');
    setImCode('');
    toggleFlgStatus(toggleFlgStatus(flgStatusEnum.active));
    setModalMachineType([DEFAULT_MACHINE_TYPE]);
    setModalMemo('');
    setModalMfgNo('');
    setModalECabinetNo('');
  };

  useEffect(() => {
    setModalRecordYear(machineItem ? machineItem.recordYear : '');
    setModalDeliveryCode(machineItem ? machineItem.deliveryCode : '');
    setModalMachineModel(machineItem ? machineItem.machineModel : '');
    setModalMachineSerialNumber(
      machineItem ? machineItem.machineSerialNumber : '',
    );
    setImCode(machineItem ? machineItem.imCode : '');
    toggleFlgStatus(machineItem?.flgStatus);
    setModalMachineType([
      machineItem
        ? MACHINE_TYPE_LIST.find(
            ({id, idString}) =>
              id === machineItem.machineTypeId ||
              idString === machineItem.machineTypeId,
          )
        : DEFAULT_MACHINE_TYPE,
    ]);
    setModalMemo(machineItem ? machineItem.memo : '');
    setModalMfgNo(machineItem ? machineItem.mfgNo : '');
    setModalECabinetNo(machineItem ? machineItem.eCabinetNo : '');
  }, [machineItem]);
  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalDepartment"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalDepartmentLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalMachineForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalMachineLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="modalRecordYear" className="form-label">
                        年度*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalRecordYear"
                        name="modalRecordYear"
                        value={modalRecordYear}
                        onChange={(e) => setModalRecordYear(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalDeliveryCode" className="form-label">
                        交機編號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalDeliveryCode"
                        name="modalDeliveryCode"
                        value={modalDeliveryCode}
                        onChange={(e) => setModalDeliveryCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMachineModel" className="form-label">
                        機械型式*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMachineModel"
                        name="modalMachineModel"
                        value={modalMachineModel}
                        onChange={(e) => setModalMachineModel(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="modalMachineSerialNumber"
                        className="form-label"
                      >
                        機械番號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMachineSerialNumber"
                        name="modalMachineSerialNumber"
                        value={modalMachineSerialNumber}
                        onChange={(e) =>
                          setModalMachineSerialNumber(e.target.value)
                        }
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="machine-modal-im-code"
                        className="form-label"
                      >
                        IM代表號碼*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="machine-modal-im-code"
                        name="modalMachineIMCode"
                        value={imCode}
                        onChange={(e) => setImCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMachineType" className="form-label">
                        機種*
                      </label>
                      <Typeahead
                        id="modalMachineType"
                        size="sm"
                        ref={typeInputReference}
                        onChange={(data) => {
                          console.log('machine type changed', data);
                          setModalMachineType(data);
                        }}
                        selected={modalMachineType}
                        inputProps={{required: true}}
                        options={MACHINE_TYPE_LIST.filter(
                          (item) => item.id !== 0,
                        )}
                        // labelKey="machineTypeName"
                        onBlur={() => {
                          if (modalMachineType.length !== 0) {
                            return;
                          }
                          typeInputReference.current.clear();
                        }}
                        renderInput={({
                          inputRef,
                          referenceElementRef,
                          ...inputProps
                        }) => (
                          <input
                            {...inputProps}
                            className="rbt-input-main form-control rbt-input form-control-sm form-select"
                            ref={(node) => {
                              inputRef(node);
                              referenceElementRef(node);
                            }}
                          />
                        )}
                        renderMenu={(results, menuProps) => (
                          <Menu {...menuProps} maxHeight="90px">
                            {results.map((result, index) => (
                              <MenuItem
                                option={result}
                                position={index}
                                key={index}
                              >
                                {result.label}
                              </MenuItem>
                            ))}
                          </Menu>
                        )}
                      />
                    </div>
                    {modalMachineType[0]?.id === 14 && (
                      <>
                        <div className="col-6">
                          <label htmlFor="mfgNo" className="form-label">
                            {`製造編號`}
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="mfgNo"
                            name="mfgNo"
                            value={modalMfgNo || ''}
                            onChange={(e) => setModalMfgNo(e.target.value)}
                          />
                        </div>
                        <div className="col-6">
                          <label htmlFor="eCabinetNo" className="form-label">
                            電器箱番號
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="eCabinetNo"
                            name="eCabinetNo"
                            value={modalECabinetNo || ''}
                            onChange={(e) => setModalECabinetNo(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-6">
                      <label htmlFor="modalMemo" className="form-label">
                        備註
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMemo"
                        name="modalMemo"
                        value={modalMemo}
                        onChange={(e) => setModalMemo(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default MachineModal;
